import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Showcase motion type; loads only when Motion resolves on. */
export const LazyShowcase = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/showcase" */ './Showcase'), 'Showcase');
